import { render, staticRenderFns } from "./WeekScheduleWidget.vue?vue&type=template&id=9f1ce428&"
import script from "./WeekScheduleWidget.vue?vue&type=script&lang=ts&"
export * from "./WeekScheduleWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports